import type { HelpFile } from '../../types/help'
import { ServiceAccountDetailTestIds } from '../../../testids/ServiceAccountDetailTestIds'

export const serviceAccountDetailHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [ServiceAccountDetailTestIds.serviceAccountDetailPage]:
      'Detailseite eines einzelnen Servicekontos — Übersicht, API-Schlüssel und zugewiesene Rollen.',
    [ServiceAccountDetailTestIds.cardOverview]:
      'Kerndaten des Servicekontos: Name, Beschreibung, Status, Erstellungsdatum und Anzahl derzeit aktiver API-Schlüssel.',
    [ServiceAccountDetailTestIds.cardOverviewTitle]: null,
    [ServiceAccountDetailTestIds.cardApiKeysTitle]: null,
    [ServiceAccountDetailTestIds.cardRolesTitle]: null,
    [ServiceAccountDetailTestIds.cardApiKeys]:
      'API-Schlüssel, die für dieses Servicekonto erzeugt wurden. Jeder Schlüssel trägt dieselben Autorisierungsrollen wie das Konto selbst.',
    [ServiceAccountDetailTestIds.cardRoles]:
      'Autorisierungsrollen, die diesem Servicekonto zugewiesen sind. Über „Rolle zuweisen“ können weitere Rollen vergeben werden; mit „Entfernen“ in der Zeile wird eine Rolle widerrufen.',
    [ServiceAccountDetailTestIds.btnEditServiceAccount]:
      'Name und Beschreibung des Servicekontos bearbeiten. Eine Namensänderung macht bestehende API-Schlüssel nicht ungültig.',
    [ServiceAccountDetailTestIds.btnDeactivateServiceAccount]:
      'Dieses Servicekonto deaktivieren und alle aktiven API-Schlüssel sofort widerrufen. Das Konto kann später reaktiviert werden — Schlüssel müssen neu erzeugt werden.',
    [ServiceAccountDetailTestIds.btnReactivateServiceAccount]:
      'Dieses Servicekonto wieder auf aktiv setzen. Bestehende Schlüssel bleiben widerrufen; erzeugen Sie neue Schlüssel, um API-Zugriff zu ermöglichen.',
    [ServiceAccountDetailTestIds.btnMintApiKey]:
      'Neuen API-Schlüssel für dieses Servicekonto erzeugen. Der Klartextschlüssel wird genau einmal angezeigt und nicht gespeichert — kopieren Sie ihn vor dem Schließen.',
    [ServiceAccountDetailTestIds.btnMintEmpty]: null,
    [ServiceAccountDetailTestIds.apiKeysEmpty]: null,
    [ServiceAccountDetailTestIds.apiKeysError]: null,
    [ServiceAccountDetailTestIds.rolesEmpty]: null,
    [ServiceAccountDetailTestIds.badgeDetailStatus]:
      'Aktueller Status des Servicekontos — aktiv oder inaktiv.',
    [ServiceAccountDetailTestIds.badgeDetailActiveKeys]:
      'Anzahl der API-Schlüssel, die für dieses Konto derzeit im Status „Aktiv“ sind.',
    [ServiceAccountDetailTestIds.colKeyName]:
      'Anzeigename, der dem API-Schlüssel beim Erzeugen gegeben wurde.',
    [ServiceAccountDetailTestIds.colKeyPrefix]:
      'Zwölfstelliges Präfix zur Identifikation — der vollständige Schlüssel wird nach dem Erzeugen nicht erneut angezeigt.',
    [ServiceAccountDetailTestIds.colKeyLastUsed]:
      'Zeitstempel der letzten erfolgreichen Authentifizierung mit diesem Schlüssel. Leer, wenn der Schlüssel noch nie verwendet wurde.',
    [ServiceAccountDetailTestIds.colKeyRateLimit]:
      'Anfragen pro Minute, die für den Schlüssel erlaubt sind. Der Standardwert gilt, wenn keine Schlüssel-spezifische Überschreibung konfiguriert ist.',
    [ServiceAccountDetailTestIds.colKeyStatus]:
      'Effektiver Status: Widerrufen > Inaktiv > Abgelaufen > Aktiv. Der höchstrangige zutreffende Zustand gewinnt.',
    [ServiceAccountDetailTestIds.colKeyActions]:
      'Aktionen pro Schlüssel — aktuell nur Widerrufen für aktive Schlüssel.',
    [ServiceAccountDetailTestIds.btnRevokePrefix()]:
      'Diesen API-Schlüssel dauerhaft widerrufen. Authentifizierung mit dem Schlüssel schlägt sofort fehl.',
    [ServiceAccountDetailTestIds.editDialogTitle]: null,
    [ServiceAccountDetailTestIds.editForm]: null,
    [ServiceAccountDetailTestIds.editInputName]:
      'Aktualisierter Servicekonto-Name (1–100 Zeichen). Eine Umbenennung erhält alle bestehenden Schlüssel.',
    [ServiceAccountDetailTestIds.editInputDescription]:
      'Aktualisierte Freitextbeschreibung (bis zu 500 Zeichen).',
    [ServiceAccountDetailTestIds.deactivateDialogTitle]: null,
    [ServiceAccountDetailTestIds.deactivateDialogBody]: null,
    [ServiceAccountDetailTestIds.btnAssignRole]:
      'Öffnet den Dialog „Rolle zuweisen“, um diesem Servicekonto eine weitere Autorisierungsrolle zu gewähren.',
    [ServiceAccountDetailTestIds.btnAssignRoleEmpty]: null,
    [ServiceAccountDetailTestIds.rolesLoading]: null,
    [ServiceAccountDetailTestIds.rolesError]: null,
    [ServiceAccountDetailTestIds.colRoleName]:
      'Rollenname — verlinkt auf die Rollen-Detailseite, auf der die durch die Rolle gewährten Berechtigungen sichtbar sind.',
    [ServiceAccountDetailTestIds.colRoleDescription]:
      'Beschreibung der Rolle.',
    [ServiceAccountDetailTestIds.colRoleAssignedBy]:
      'Anzeigename des Benutzers, der die Rolle zugewiesen hat. Leer, wenn die Zeile durch DB-Testdaten erstellt wurde.',
    [ServiceAccountDetailTestIds.colRoleAssignedAt]:
      'Zeitpunkt, zu dem die Rolle dem Servicekonto zugewiesen wurde.',
    [ServiceAccountDetailTestIds.colRoleActions]:
      'Aktionen pro Zeile — derzeit nur Entfernen.',
    [ServiceAccountDetailTestIds.btnRemoveRolePrefix()]:
      'Öffnet den Bestätigungsdialog „Rolle entfernen“, um diese Rolle vom Servicekonto zu widerrufen.',
  },
}
